import React from "react";
import SignupForm from "../components/sections/SignupForm";

const Signup = (props) => {
  return <SignupForm className="illustration-section-02" />;
};

export default Signup;
